/* eslint-disable */
export default {
  add: 'Aggiungi',
  noCalls: 'Nessuna chiamata disponibile',
  activeCall: 'Chiamata attiva',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
